function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { timestampInSeconds } from '@sentry/utils';
import { DEFAULT_BROWSER_FLUSH_INTERVAL, NAME_AND_TAG_KEY_NORMALIZATION_REGEX, SET_METRIC_TYPE } from './constants.js';
import { METRIC_MAP } from './instance.js';
import { updateMetricSummaryOnActiveSpan } from './metric-summary.js';
import { sanitizeTags, getBucketKey } from './utils.js';
/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */

var BrowserMetricsAggregator = /*#__PURE__*/function () {
  // TODO(@anonrig): Use FinalizationRegistry to have a proper way of flushing the buckets
  // when the aggregator is garbage collected.
  // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/FinalizationRegistry
  function BrowserMetricsAggregator(_client) {
    var _this = this;

    _classCallCheck(this, BrowserMetricsAggregator);

    this._client = _client;
    this._buckets = new Map();
    this._interval = setInterval(function () {
      return _this.flush();
    }, DEFAULT_BROWSER_FLUSH_INTERVAL);
  }
  /**
   * @inheritDoc
   */


  _createClass(BrowserMetricsAggregator, [{
    key: "add",
    value: function add(metricType, unsanitizedName, value) {
      var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'none';
      var unsanitizedTags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var maybeFloatTimestamp = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : timestampInSeconds();
      var timestamp = Math.floor(maybeFloatTimestamp);
      var name = unsanitizedName.replace(NAME_AND_TAG_KEY_NORMALIZATION_REGEX, '_');
      var tags = sanitizeTags(unsanitizedTags);
      var bucketKey = getBucketKey(metricType, name, unit, tags);

      var bucketItem = this._buckets.get(bucketKey); // If this is a set metric, we need to calculate the delta from the previous weight.


      var previousWeight = bucketItem && metricType === SET_METRIC_TYPE ? bucketItem.metric.weight : 0;

      if (bucketItem) {
        bucketItem.metric.add(value); // TODO(abhi): Do we need this check?

        if (bucketItem.timestamp < timestamp) {
          bucketItem.timestamp = timestamp;
        }
      } else {
        bucketItem = {
          // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
          metric: new METRIC_MAP[metricType](value),
          timestamp: timestamp,
          metricType: metricType,
          name: name,
          unit: unit,
          tags: tags
        };

        this._buckets.set(bucketKey, bucketItem);
      } // If value is a string, it's a set metric so calculate the delta from the previous weight.


      var val = typeof value === 'string' ? bucketItem.metric.weight - previousWeight : value;
      updateMetricSummaryOnActiveSpan(metricType, name, val, unit, unsanitizedTags, bucketKey);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "flush",
    value: function flush() {
      // short circuit if buckets are empty.
      if (this._buckets.size === 0) {
        return;
      }

      if (this._client.captureAggregateMetrics) {
        // TODO(@anonrig): Use Object.values() when we support ES6+
        var metricBuckets = Array.from(this._buckets).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              bucketItem = _ref2[1];

          return bucketItem;
        });

        this._client.captureAggregateMetrics(metricBuckets);
      }

      this._buckets.clear();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "close",
    value: function close() {
      clearInterval(this._interval);
      this.flush();
    }
  }]);

  return BrowserMetricsAggregator;
}();

export { BrowserMetricsAggregator };